<!-- src/app/teams/multichat/multichat.component.html -->

<div class="main-container multi-turn-team" dir="ltr">
  <div class="multichat-header">

    <mat-tab-group
      #tabGroup
      [selectedIndex]="selectedTabIndex"
      [preserveContent]="true"
      animationDuration="0ms"
      (selectedIndexChange)="onTabIndexChange($event)"
      class="multichat-tabs">

      <!-- Summary tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="iq-tab-label" id="executiveSummaryTab">
            <i class="fa-solid fa-clipboard-list iq-tab-icon iq-tab-icon--summary" aria-hidden="true"></i>
            <span>Summary</span>
            <span
              *ngIf="summarySucceeded"
              class="iq-tab-status iq-tab-status--ok"
              aria-label="Summary ready"
            >
              ➤
            </span>
          </span>
        </ng-template>

        <div class="messages-container-inner">
          <div class="summary-center-state" *ngIf="!teamSummary && !isLoading && !liveTranscriptHtml">
            <div class="summary-center-card">
              <div class="summary-center-icon">
                <i class="fa-solid fa-clipboard-list" aria-hidden="true"></i>
              </div>
              <h3>Summary</h3>
              <p>Once the comparison finishes, the consolidated answer will appear here in the center of the workspace.</p>
            </div>
          </div>

          <div class="summary-loading-state" *ngIf="isLoading && !teamSummary">
            <app-bird-loader label="Building summary"></app-bird-loader>
            <p>Comparing model outputs and organizing the key findings...</p>
          </div>

          <div class="message-content" *ngIf="liveTranscriptHtml || teamSummary">
            <div class="markdown prism-content" *ngIf="liveTranscriptHtml" [innerHTML]="liveTranscriptHtml"></div>

            <div class="markdown prism-content" *ngIf="teamSummary" [innerHTML]="formattedSummary" appCodeHighlight></div>

            <div class="export-row" *ngIf="teamSummary">
              <button class="btn-red-bigal me-3" (click)="exportToPDF()">Export to PDF</button>
              <button class="btn-red-bigal" (click)="exportToDOCX()">Export to DOCX</button>
            </div>
          </div>

          <div class="error-message" *ngIf="summaryError && !teamSummary">{{ summaryError }}</div>
        </div>
      </mat-tab>

      <!-- 0..N) Dynamic model tabs with status icon -->
      <mat-tab *ngFor="let modelId of selectedModels; index as i">
        <ng-template mat-tab-label>
          <span class="iq-tab-label iq-tab-label--writer" [id]="'executiveModelTab' + (i + 1)">
            <i class="fa-solid fa-brain iq-tab-icon iq-tab-icon--writer" aria-hidden="true"></i>
            <span class="iq-tab-label__title">{{ tabLabel(modelId) }}</span>
            <span
              *ngIf="tabStatuses[i] === 'success'"
              class="iq-tab-status iq-tab-status--ok"
              aria-label="Success"
              >✔</span
            >
            <span
              *ngIf="tabStatuses[i] === 'error'"
              class="iq-tab-status iq-tab-status--err"
              aria-label="Error"
              >✖</span
            >
          </span>
        </ng-template>

        <div class="messages-container-inner">
          <div class="chat-placeholder-grid-container" *ngIf="!rawOutputs[i] && !isLoading">
            <img
              *ngIf="hasVendorLogo(modelId); else defaultLogo"
              [src]="getVendorLogo(modelId)"
              class="grid-item-logo vendor-logo"
              [alt]="modelName(modelId) + ' logo'" />

            <ng-template #defaultLogo>
              <img src="assets/svg/sosexy.png" class="grid-item-logo" />
            </ng-template> 

            <h1 class="placeholder-subtitle bigal-sub">
              {{ getModelPlaceholder(i) || 'Waiting for response...' }}
            </h1>
          </div>

          <div class="message-content" *ngIf="rawOutputs[i]">
            <div class="markdown prism-content" [innerHTML]="formattedOutputs[i]" appCodeHighlight></div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="tosskimssalad">
      <button
        #videoMenuTrigger
        type="button"
        class=" lovesheetali"
        id="moreSection"
        (click)="toggleVideoGeneratorMenu(); $event.stopPropagation()"
        [attr.aria-expanded]="showVideoGeneratorMenu"
        aria-haspopup="menu"
        aria-label="Open tools menu">
        <span class="btn-icon">
          <mat-icon svgIcon="settings"></mat-icon>
        </span>
    
      </button>
    </div>
   
<!-- [attr.aria-expanded]="menuOpen" -->
  </div>

  <div class="multichat-request-status" *ngIf="isLoading || error" aria-live="polite">
    <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>
    <div class="error-message" *ngIf="error">{{ error }}</div>
  </div>

  <div class="bottomcontainer">
    <button
      id="aiCoachFab"
      type="button"
      class="coach-fab"
      [disabled]="coachFabBusy"
      (click)="triggerCoachFab()"
      aria-label="Invoke AI Coach"
    >
      <i class="fa-solid fa-brain" aria-hidden="true"></i>
      <span>{{ coachFabText }}</span>
    </button>

    <div class="input-container">
      <div class="composer-shell">
        <div class="textarea-wrapper" [class.menu-open]="showVideoGeneratorMenu">
         <textarea
  #userInputTextarea
  id="executiveChatInput"
  class="user-input-textarea"
  [(ngModel)]="inputText"
  rows="1"
  [placeholder]="isFocused ? '' : executiveComposerPlaceholder"
  [disabled]="isLoading || audioActive"
  [class.disabled-typing]="audioActive"
  (focus)="onTextareaFocus()"
  (blur)="onTextareaBlur()"
  (keydown.enter)="onEnter($event)"
  (keydown.shift.enter)="onShiftEnter($event, userInputTextarea)"
  (keydown)="handleTextareaKeydown($event)"
  (input)="autoResizeTextarea()"
  dir="auto">
</textarea>

          <!-- Show send only when user typed text (no audio-wave fallback). -->
          <button
            *ngIf="inputText?.trim()?.length"
            id="sendMessageButton"
            class="btn-send-fixed"
            type="button"
            (click)="onSubmit()"
            [disabled]="isLoading || !inputText?.trim()?.length">
            <i class="fas fa-arrow-up send-arrow-icon" aria-hidden="true"></i>
          </button>

          <div class="model-grid-inside">
            <div class="grid-item-inside selector repeat-selector" *ngIf="messageHistory.length > 0">
              <button
                id="previousPromptsBtn"
                class="elephant-btn lovesheet33"
                matTooltip="Click through your prompts (or press ↑)"
                (click)="recallPreviousMessage()"
                aria-label="Repeat previous prompt">
                <span class="btn-icon">
                  <i class="fas fa-clock-rotate-left"></i>
                </span>
                <span class="btn-text">Repeat Prompt</span>
              </button>
              <!-- <span class="repeat-hint" *ngIf="messageHistory.length > 0">Repeat prompt</span> -->
            </div>

            <div class="grid-item-inside selector team-catalog-selector">
              <button
                type="button"
                id="executiveAiSelector"
                class="elephant-btn lovesheet33"
                matTooltip="Choose four models (same catalog as Clari Chat)"
                (click)="openModelDialog()"
                aria-label="Open team model catalog">
                <span class="btn-icon">
                  <i class="fas fa-layer-group"></i>
                </span>
                <span class="btn-text">AI Catalog</span>
              </button>
            </div>

            <div class="grid-item-inside selector tools-selector" #menuContainer>
              <div class="video-menu-anchor" (click)="$event.stopPropagation()">
                <div
                  #videoMenu
                  class="video-generator-menu"
                  [class.open]="showVideoGeneratorMenu"
                  *ngIf="showVideoGeneratorMenu">

                  <div class="model-specs-section">
                    <div class="menu-section-title">Model Specs</div>
                    <div class="model-spec-list">
                      <ng-container *ngFor="let modelId of selectedModels; let i = index">
                        <button
                          type="button"
                          class="model-spec-menu-item"
                          (click)="openModelSpecDialog(modelId); showVideoGeneratorMenu = false">
                          <img
                            [src]="modelLogo(modelId)"
                            class="model-logos2"
                            [alt]="modelName(modelId) + ' logo'" />
                          <span>{{ modelName(modelId) }}</span>
                          <i class="fas fa-info-circle"></i>
                        </button>
                      </ng-container>
                    </div>
                  </div>

                  <div class="export-section">
                    <div class="menu-section-title">Export</div>
                    <button type="button" (click)="exportToPDF(); showVideoGeneratorMenu = false">
                      <span class="icon">📄</span> Export to PDF
                    </button>
                    <button type="button" (click)="exportToDOCX(); showVideoGeneratorMenu = false">
                      <span class="icon">📝</span> Export to DOCX
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
